import CustomersApi from '../../api/CustomersApi';

const state = {
  onboardingStatus: null,
};

const actions = {
  async init({ commit }) {
    const onboardingStatus = await CustomersApi.getOnboradingStatus();
    commit('setOnboardingStatus', onboardingStatus);
  },
};

const mutations = {
  setOnboardingStatus(state, onboardingStatus) {
    state.onboardingStatus = onboardingStatus; // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/customerState.js